// Small timezone utilities for the frontend (uses Intl.DateTimeFormat).

export const TZ_OPTIONS = [
  { value: "Asia/Jakarta", label: "WIB — Asia/Jakarta" },
  { value: "Asia/Makassar", label: "WITA — Asia/Makassar" },
  { value: "Asia/Jayapura", label: "WIT — Asia/Jayapura" },
];

export function tzLabel(tz) {
  const found = TZ_OPTIONS.find((o) => o.value === tz);
  return found ? found.label : tz;
}

export function tzShort(tz) {
  if (!tz) return "";
  if (tz === "Asia/Jakarta") return "WIB";
  if (tz === "Asia/Makassar") return "WITA";
  if (tz === "Asia/Jayapura") return "WIT";
  return tz;
}

export function formatInTZ(date, tz, options = {}) {
  try {
    return new Intl.DateTimeFormat("id-ID", { timeZone: tz, ...options }).format(date);
  } catch {
    return "";
  }
}

export function todayInTZ(tz) {
  return formatInTZ(new Date(), tz, {
    weekday: "long",
    day: "2-digit",
    month: "long",
    year: "numeric",
  });
}

export function clockInTZ(tz) {
  return formatInTZ(new Date(), tz, {
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: false,
  });
}
